/* eslint-disable */

import { useState, useContext } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";

import { RiPushpinFill } from "react-icons/ri";
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);
import { CiFolderOn } from "react-icons/ci";


function IndividualFolder({ item, handleFoldersPinned, setCurrFolderData, setCurrUserTab, setFilesList }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [pinnedHover, setPinnedHover] = useState(false);
  const currGroupId = location.pathname.split("/")[2] ? location.pathname.split("/")[2] : "";

  const [currFolder, setCurrFolder] = setCurrFolderData

  // const setCurrFolder = (e) => {
  //   console.log(e);
  // }

  return (
    <tr className={`hover:font-bold ${currFolder?.id === item.id ? "bg-lightPrimary" : "bg-white"}`}
      onClick={() => {
        setCurrFolder({id: item.id, name: item.name})
        setFilesList(item.files)
        setCurrUserTab({
          name: "Notes"
        });
      }}
      onMouseEnter={() => setPinnedHover(true)}
      onMouseLeave={() => setPinnedHover(false)}
    >
      <td className="border-b border-gray-200 px-2 text-gray-800 py-1 text-xs">

        <div className="flex items-center">
          <div className="h-6 w-6 flex-shrink-0">
            <CiFolderOn className="h-full w-full text-gray-600 " />
          </div>
          <div className="ml-2 flex flex-col">
            <p className="whitespace-no-wrap text-xs lg:text-sm">{item.name}</p>
            <p className="text-gray-500 text-xs">{dayjs(item.createdAt).format('lll')}</p>
          </div>
        </div>
      </td>
      <td className="border-b border-gray-200 pr-1 pl-1 text-xs">
        {/* <p className="whitespace-no-wrap">Defence</p> */}
        <div className=""
          onClick={(e) => {
            e.stopPropagation()
            handleFoldersPinned(item.id)
          }}
        >
          <RiPushpinFill className={`w-4 h-4 ${item.isPinned ? "text-headPrimary" : pinnedHover ? "text-[#cfe2f4]" : "text-white"}`} />
        </div>

      </td>

    </tr>
  )
}

export default IndividualFolder